import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { AppleApplication } from '@rocksoft/apple-sync-sdk';

export type ConfiguredApplication = AppleApplication & { deviceId: string };

export function selectDeviceConfiguredApplicationsId(application: ConfiguredApplication) {
  const key: string = [application.deviceId, application.bundleIdentifier].join('-');

  return key;
}

export const adapter: EntityAdapter<ConfiguredApplication> = createEntityAdapter<ConfiguredApplication>({
  selectId: selectDeviceConfiguredApplicationsId,
});

export type DeviceConfiguredApplicationsState = EntityState<ConfiguredApplication>;

export const initialState: DeviceConfiguredApplicationsState = adapter.getInitialState();
